import Blue from "~/core";

new Blue({
  name: "Hero",
  selector: ".hero",
  setup(hero) {
    const isMobile = () => window.innerWidth < 991;

    const setFormMargin = () => {
      if (isMobile() && hero.classList.contains("hero--form")) {
        let form = hero.querySelector(".heroForm");
        hero.style.marginBottom = `${form.offsetHeight}px`;
      }
    };

    window.addEventListener("resize", () => {
      setFormMargin();
    });
    setFormMargin();
  }
});
